import React from 'react';
const FlowSvg = ({ color = '', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      {...props}
    >
      <path
        d="M4.15802 8.4267H12.9047V10.0694H13.758V7.57337H8.95802V5.8667H8.10469V7.57337H3.30469V10.0694H4.15802V8.4267Z"
        fill={color}
      />
      <path
        d="M6.4 10.6666H1.06667C0.783769 10.6666 0.512458 10.779 0.312419 10.979C0.112381 11.1791 0 11.4504 0 11.7333V14.9333C0 15.2162 0.112381 15.4875 0.312419 15.6875C0.512458 15.8876 0.783769 16 1.06667 16H6.4C6.6829 16 6.95421 15.8876 7.15425 15.6875C7.35428 15.4875 7.46667 15.2162 7.46667 14.9333V11.7333C7.46667 11.4504 7.35428 11.1791 7.15425 10.979C6.95421 10.779 6.6829 10.6666 6.4 10.6666ZM1.06667 14.9333V11.7333H6.4V14.9333H1.06667Z"
        fill={color}
      />
      <path
        d="M16.0016 10.6666H10.6682C10.3853 10.6666 10.114 10.779 9.91398 10.979C9.71394 11.1791 9.60156 11.4504 9.60156 11.7333V14.9333C9.60156 15.2162 9.71394 15.4875 9.91398 15.6875C10.114 15.8876 10.3853 16 10.6682 16H16.0016C16.2845 16 16.5558 15.8876 16.7558 15.6875C16.9558 15.4875 17.0682 15.2162 17.0682 14.9333V11.7333C17.0682 11.4504 16.9558 11.1791 16.7558 10.979C16.5558 10.779 16.2845 10.6666 16.0016 10.6666ZM10.6682 14.9333V11.7333H16.0016V14.9333H10.6682Z"
        fill={color}
      />
      <path
        d="M5.86354 5.33333H11.1969C11.4798 5.33333 11.7511 5.22095 11.9511 5.02091C12.1512 4.82087 12.2635 4.54956 12.2635 4.26667V1.06667C12.2635 0.783769 12.1512 0.512458 11.9511 0.312419C11.7511 0.112381 11.4798 0 11.1969 0H5.86354C5.58064 0 5.30933 0.112381 5.10929 0.312419C4.90926 0.512458 4.79688 0.783769 4.79688 1.06667V4.26667C4.79688 4.54956 4.90926 4.82087 5.10929 5.02091C5.30933 5.22095 5.58064 5.33333 5.86354 5.33333ZM5.86354 1.06667H11.1969V4.26667H5.86354V1.06667Z"
        fill={color}
      />
    </svg>
  );
};

export default FlowSvg;
